module.exports = __webpack_public_path__ + "img/erp-logos_0004_wiise.a8237b44.jpg";